import { number_to_price } from '../../../../helper/common'
import { RightOutlined, DownOutlined } from '@ant-design/icons'
import { useState } from 'react'
import { checkDurationUsageDate } from '../../../../helper/formatDate'
import './index.scss'
export default function AutomatedTrafficFineNotificationPaymentInfo({
  vehicles = [],
  services = [],
  subTotalAmount = 0,
  taxAmount = 0,
  discountAmount = 0,
  usageDate,
  totalAmount = 0
}) {
  const [showAllVehicles, setShowAllVehicles] = useState(false)

  const displayedVehicles = showAllVehicles ? vehicles : vehicles.slice(0, 1)
  return (
    <div className="AutomatedTrafficFineNotificationPaymentInfo">
      <div className="AutomatedTrafficFineNotificationPaymentInfo_item">
        <div className="AutomatedTrafficFineNotificationPaymentInfo_title">Thông tin giao dịch</div>
        {/* Thông tin dịch vụ */}
        {services.map((service, index) => (
          <div key={index} className="AutomatedTrafficFineNotificationPaymentInfo_content">
            <div className="content_lable">Gói dịch vụ {services.length > 1 ? `(${index + 1})` : ''}</div>
            <div className="content_value">{service?.productName || '-'}</div>
          </div>
        ))}

        {/* Thông tin xe */}
        {displayedVehicles.map((vehicle, index) => (
          <div key={index} className="AutomatedTrafficFineNotificationPaymentInfo_content">
            <div className="content_lable">Thông tin xe {vehicles.length > 1 && (showAllVehicles || index > 0) ? `(${index + 1})` : ''}</div>
            <div className="content_value" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>{vehicle.plate || '-'}</span>
              {vehicles.length > 1 &&
                index === 0 &&
                (showAllVehicles ? (
                  <DownOutlined style={{ cursor: 'pointer', marginLeft: '8px' }} onClick={() => setShowAllVehicles(false)} />
                ) : (
                  <RightOutlined style={{ cursor: 'pointer', marginLeft: '8px' }} onClick={() => setShowAllVehicles(true)} />
                ))}
            </div>
          </div>
        ))}

        <div className="AutomatedTrafficFineNotificationPaymentInfo_content">
          <div className="content_lable">Thời hạn</div>
          <div className="content_value">{checkDurationUsageDate(usageDate)}</div>
        </div>
      </div>
      <div className="AutomatedTrafficFineNotificationPaymentInfo_item">
        <div className="AutomatedTrafficFineNotificationPaymentInfo_title">Số tiền giao dịch</div>
        <div className="AutomatedTrafficFineNotificationPaymentInfo_content">
          <div className="content_lable">Số tiền</div>
          <div className="content_value">{number_to_price(subTotalAmount)}đ</div>
        </div>
        <div className="AutomatedTrafficFineNotificationPaymentInfo_content">
          <div className="content_lable">Thuế VAT (10%)</div>
          <div className="content_value">{number_to_price(taxAmount)}đ</div>
        </div>
        <div className="AutomatedTrafficFineNotificationPaymentInfo_note">Vui lòng liên hệ CSKH nếu cần xuất Hoá đơn GTGT.</div>
        <div className="AutomatedTrafficFineNotificationPaymentInfo_content">
          <div className="content_lable">Tổng tiền thanh toán</div>
          <div className="content_value total-amount">{number_to_price(totalAmount)}đ</div>
        </div>
      </div>
    </div>
  )
}
